//
const reg = /search\("(.*)".*\)/
export function filterToolArgs(val) {
  const match = val?.match(reg)
  if (match) {
    return match[1]
  }
  return val
}
const reg_day = /recency_days=(\d+)/
export function filterToolDay(val) {
  const match = val?.match(reg_day)
  if (match) {
    return match[1]
  }
  return ''
}
export function filterDocCounts(val) {
  if (!val) {
    val = 0
  }
  if (val < 10000) {
    return `约${val}字`
  } else {
    const num = (val / 10000).toFixed(2)
    return `约${num}字`
  }
}
